import React, { useState } from "react";
import axios from "axios";
import { Container, Button, Form, Spinner, Alert } from "react-bootstrap";
import logo from "./logo.jpg";
function App() {
  const [file, setFile] = useState(null);
  const [jsonResult, setJsonResult] = useState("");
  const [loading, setLoading] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [userText, setUserText] = useState("");
  const [ocrText, setOcrText] = useState("");
  const [ocrMethod, setOcrMethod] = useState("InvoiceParser");

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    setFile(uploadedFile);
    const fileUrl = URL.createObjectURL(uploadedFile);
    setPdfUrl(fileUrl);
  };
  const downloadOCRResponse = () => {
    if (!ocrText) return;
    const blob = new Blob([ocrText], { type: "text/plain;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "ocr_response.txt");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const downloadFullInvoiceParserResponse = async () => {
    try {
      const res = await axios.get('https://backend-nia.caigroup.ai/invoice-parser-response', {
        responseType: 'blob', // important to treat response as a Blob
      });

      const url = URL.createObjectURL(res.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "invoiceparser_response.txt");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error during API call:', error);
    }
  };

  const handleUpload = async () => {
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    setLoading(true);
    const uploadUrl = ocrMethod === "InvoiceParser"
      ? "https://backend-nia.caigroup.ai/uploadOnGCPInvoiceParser"
      : "https://backend-nia.caigroup.ai/uploadOnGCP";
    try {
      const ocrResponse = await axios.post(uploadUrl, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log(JSON.stringify(ocrResponse));
      const extractedText = ocrResponse.data;
      let textToSend;
      if (ocrMethod === "InvoiceParser") {
        textToSend = `
Invoice Header:
${Object.entries(extractedText.header).map(([key, value]) => `${key}: ${value}`).join('\n')}

Line Items:
${extractedText.line_items.map((item, index) =>
          `Item ${index + 1}:\n${Object.entries(item).map(([k, v]) => `${k}: ${v}`).join('\n')}`
        ).join('\n\n')}
`;
      }
      else {

        // Ensure it's a string, not an array it is for text api of GCP
        textToSend = Array.isArray(extractedText) ? extractedText.join("\n") : extractedText;
      }



      setOcrText(textToSend);
      // Step 2: Send extracted text to ChatGPT
      const chatResponse = await axios.post("https://backend-nia.caigroup.ai/chatgpt", {
        extracted_text: textToSend,
        user_input: userText,
      });

      setJsonResult(chatResponse.data.json);
    } catch (error) {
      console.log(error);
      alert("Failed to process the file.");
    }
    setLoading(false);
  };

  // const downloadCSV = () => {
  //   if (!jsonResult) return;

  //   // Remove markdown code block formatting
  //   const cleaned = jsonResult.replace(/```json|```/g, "").trim();

  //   try {
  //     const parsed = JSON.parse(cleaned);
  //     const headers = parsed.header || {};
  //     const items = parsed.line_items || [];

  //     const headerKeys = Object.keys(headers);
  //     const itemKeys = items.length > 0 ? Object.keys(items[0]) : [];

  //     const csvHeaders = [...headerKeys, ...itemKeys];

  //     const csvRows = items.length > 0
  //       ? items.map((item) => {
  //         const row = [
  //           ...headerKeys.map(k => `"${headers[k] ?? ""}"`),
  //           ...itemKeys.map(k => `"${item[k] ?? ""}"`)
  //         ];
  //         return row.join(",");
  //       })
  //       : [
  //         [...headerKeys.map(k => `"${headers[k] ?? ""}"`)].join(",")
  //       ];

  //     const csvContent = [csvHeaders.join(","), ...csvRows].join("\n");
  //     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  //     const url = URL.createObjectURL(blob);

  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.setAttribute("download", "invoice.csv");
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   } catch (error) {
  //     console.error("Failed to parse or convert JSON:", error);
  //     alert("Invalid JSON format or structure.");
  //   }
  // };

  const downloadCSV = () => {
  if (!jsonResult) return;

  const cleaned = jsonResult.replace(/```json|```/g, "").trim();

  try {
    const parsed = JSON.parse(cleaned);

    // Extract line_items and treat everything else as headers
    const { line_items = [], ...headers } = parsed;

    const headerKeys = Object.keys(headers);
    const itemKeys = line_items.length > 0 ? Object.keys(line_items[0]) : [];

    const csvHeaders = [...headerKeys, ...itemKeys];

    const csvRows = line_items.length > 0
      ? line_items.map((item) => {
          const row = [
            ...headerKeys.map(k => `"${headers[k] ?? ""}"`),
            ...itemKeys.map(k => `"${item[k] ?? ""}"`)
          ];
          return row.join(",");
        })
      : [
          [...headerKeys.map(k => `"${headers[k] ?? ""}"`)].join(",")
        ];

    const csvContent = [csvHeaders.join(","), ...csvRows].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "invoice.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Failed to parse or convert JSON:", error);
    alert("Invalid JSON format or structure.");
  }
};




  return (
    <div className="mainDiv">

      <header>
        <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white   mb-3">
          <div class="container-fluid">
            <img src={logo} alt="Description" />


            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target=".navbar-collapse" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="navbar-collapse collapse d-sm-inline-flex justify-content-between">
              <ul class="navbar-nav flex-grow-1">
                <li>

                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6">
            <div className="whiteBox">
              <div className="row">
                <div className="col-md-12 margin70px">
                  <h1 className="title">1. Upload  your document</h1>
                  <Form.Group className="chooseFile">
                    <Form.Control type="file" accept=".pdf,.jpeg,.jpg,.png,.tiff,.tif" onChange={handleFileChange} />
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 margin70px">
                  <h1 className="title">2. Select  an OCR </h1>
                  <Form.Group>
                    <Form.Check
                      inline
                      type="radio"
                      label="InvoiceParser"
                      value="InvoiceParser"
                      name="ocrMethod"
                      checked={ocrMethod === "InvoiceParser"}
                      onChange={(e) => setOcrMethod(e.target.value)}
                    />
                    <Form.Check
                      inline
                      type="radio"
                      label="TextDetection"
                      value="TextDetection"
                      name="ocrMethod"
                      checked={ocrMethod === "TextDetection"}
                      onChange={(e) => setOcrMethod(e.target.value)}
                    />

                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="promptWrp">
                    <div><h1 className="title">3. Add a prompt</h1></div>
                    <div><button className="EditBtn" title="Edit Prompt">Edit</button></div>
                  </div>

                  <Form.Group>

                    <Form.Control
                      as="textarea"
                      rows={4}
                      value={userText}
                      onChange={(e) => setUserText(e.target.value)}
                      placeholder="Enter any extra instructions or comments here..."
                    />
                  </Form.Group>
                </div>
              </div>

            </div>


          </div>
          <div className="col-md-6">
            <div className="whiteBox">
              <div className="row">

                <div className="col-md-12">
                  <h1 className="title">4. Invoice Privew</h1>
                  <div className="pdfBox">
                    {pdfUrl && (
                      <embed src={pdfUrl} width="100%" height="200" type="application/pdf" />
                    )}
                  </div>
                </div>



                <div className="col-md-4">
                  <Button onClick={handleUpload} disabled={loading} className="saveBtn">
                    {loading ? <><Spinner animation="border" size="sm" /> Processing...</> : "Upload & Convert"}
                  </Button>
                </div>



                <div className="col-md-12">
                  {jsonResult && (
                    <>
                      <div className="responseHeader">
                        <div><h1 className="title">5. Download the response</h1></div>
                        <div>

                          <Button variant="success" className="responseBtn" title="Download CSV" onClick={downloadCSV}>
                            <i class="fa fa-cloud-download" aria-hidden="true"></i>CSV
                          </Button>
                          <Button variant="secondary" title="Download OCR Response" onClick={downloadOCRResponse} className="responseBtn" disabled={!ocrText}>
                            <i class="fa fa-cloud-download" aria-hidden="true"></i>OCR Response
                          </Button>
                          <Button variant="secondary" title="Download Full Invoice Parser Response" onClick={downloadFullInvoiceParserResponse} className="responseBtn" >
                            <i class="fa fa-cloud-download" aria-hidden="true"></i>Full Invoice Parser Response
                          </Button>

                        </div>
                      </div>

                      <div className="">
                        <Alert variant="secondary" className="ResponsTextBox" style={{ whiteSpace: "pre-wrap", width: "100%", maxHeight: "200px", overflowY: "auto" }}>
                          {jsonResult}
                        </Alert>
                      </div>
                    </>
                  )}
                </div>



              </div>
            </div>
          </div>



        </div>

      </div>




    </div>
  );
}

export default App;
